import type { ReactElement } from "react"

import type { LineSvgProps, Serie } from "@nivo/line"
import { ResponsiveLine } from "@nivo/line"

import { getTheme } from "../../../hooks/UseTheme"
import { NivoTheme } from "../../../themes/nivoTheme"

export type BaseLineChartProps = {
  data: Serie[]

  chartOptions?: Omit<LineSvgProps, "data">
}

export function BaseLineChart(props: Readonly<BaseLineChartProps>): ReactElement {
  const { data, chartOptions = {} } = props

  const theme = getTheme()

  return (
    <ResponsiveLine
      data={data}
      theme={NivoTheme(theme)}
      margin={{ top: 16, bottom: 50, left: 35 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      yFormat=" >-.2f"
      curve="natural"
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        truncateTickAt: 0,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "",
        legendOffset: -40,
        legendPosition: "middle",
        truncateTickAt: 0,
      }}
      colors={(line) => line.color}
      enablePoints={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabel="data.yFormatted"
      pointLabelYOffset={-12}
      enableCrosshair={false}
      useMesh={true}
      legends={[]}
      {...chartOptions}
    />
  )
}
